import { render, staticRenderFns } from "./AccountCompare.vue?vue&type=template&id=6a46dafd&scoped=true"
var script = {}
import style0 from "./AccountCompare.vue?vue&type=style&index=0&id=6a46dafd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a46dafd",
  null
  
)

export default component.exports